module.exports = __webpack_public_path__ + "img/xu1-1.42559264.png";